import React, { useEffect, useState } from 'react'
import LoadMask from '../../Utils/LoadMask'
import './styles.css';
import { apiDriverApp } from '../../../../libs/apiDriverApp';
import moment from 'moment';
import { DriversList } from '../components/time-off/DriversList';
import Calendar from '../components/time-off/Calendar';
import { StatisticsBoard } from '../components/time-off/StatisticsBoard';
import { connect } from 'react-redux';
import { DownloadModal } from '../components/time-off/components/DownloadModal'
import ManagedInOdooNotice from '../components/ManagedInOdooNotice';

const TimeOff = () => {

  const [showDlModal, setShowDlModal] = useState(false);
  const [requests, setRequests] = useState(null)
  const [typeOptions, setTypeOptions] = useState([])
  const [view, setView] = useState("list");
  const [isLoading, setIsLoading] = useState(false);
  const [downloadType, setDownloadType] = useState(null);

  const getTotalDays = (from_date, to_date) => {
    const fromDate = new Date(from_date);
    const toDate = new Date(to_date);
    const diffTime = toDate - fromDate;
    const totalDays = diffTime / (1000 * 60 * 60 * 24) + 1;
    return totalDays
  }

  const getLeaveRequests = async () => {
    try {
      setIsLoading(true)
      const today = moment().format("YYYY-MM-DD");
      const { data } = await apiDriverApp.get('api/hr/leave/');

      const formattedRequests = data
        .map(item => ({
          id: item.id,
          name: `${item.employee.user.first_name} ${item.employee.user.last_name} (${item.employee.user.username})`,
          startDate: item.from_date.split('T')[0],
          endDate: item.to_date.split('T')[0],
          status: item.status,
          type: item.leave_type.name,
          id_type: item.leave_type.id,
          dateRequested: item.latest_status.date_changed.split('T')[0],
          latestUser: item.latest_status.changed_by || '',
          duration: getTotalDays(item.from_date, item.to_date),
          startTime: item.start_time,
          endTime: item.end_time,
          employeeId: item.employee.id,
        })).filter(item => moment(item.endDate, "YYYY-MM-DD").isSameOrAfter(today))
        .sort((a, b) => {
          if (a.status === "sent" && b.status !== "sent") return -1;
          if (a.status !== "sent" && b.status === "sent") return 1;
          return moment(a.startDate, "YYYY-MM-DD").diff(moment(b.startDate, "YYYY-MM-DD"));
        });
      setRequests(formattedRequests);
      setIsLoading(false)
    } catch (error) {
      console.log(error)
      setIsLoading(false)
    }
  };

  const getLeaveTypes = async () => {
    try {
      const { data } = await apiDriverApp.get('/api/hr/leave-types/?show_all=true')
      const typeOptions = data.map(type => ({
        label: type.name,
        value: type.name,
        id: type.id
      }))
      setTypeOptions(typeOptions);
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getLeaveRequests(),
      getLeaveTypes();
  }, [])

  return (
    <div className='custom-container'>
      <div className='button-bar'>
        <h2 className='text-left font-bold'>Time Off Requests</h2>
        <div className="download-upload-buttons" style={{marginRight:'100px'}}>
          <div className="dropdown">
            <button className="btn dropdown-toggle" style={{cursor:'pointer', color:'white', backgroundColor:'#0c66e4', fontWeight:'bold'}} type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Reports
            </button>
            <div className="dropdown-menu" style={{marginTop:'10px'}} aria-labelledby="dropdownMenuButton">
              <div className="dropdown-item" style={{cursor:'pointer'}} onClick={()=>{setDownloadType('time-off'),setShowDlModal(true)}}>Download Time-Off Report</div>
              <div className="dropdown-item" style={{cursor:'pointer'}} onClick={()=>{setDownloadType('incident'),setShowDlModal(true)}}>Download Incident Report</div>
            </div>
          </div>
        </div>
      </div>


      <div className="d-flex align-items-center" style={{ gap: 15 }}>
        <button
          className="btn border border-dark rounded shadow-sm d-flex flex-row align-items-center gap-2"
          style={{ backgroundColor: view === 'list' ? '#DADADA' : 'white' }}
          onClick={() => setView("list")}
        >
          <span style={{ fontWeight: 'bold', margin: 0, cursor: 'pointer', marginLeft: 5 }}>List</span>
        </button>
        <button
          className="btn border border-dark rounded shadow-sm d-flex flex-row align-items-center gap-2"
          style={{ backgroundColor: view === 'calendar' ? '#DADADA' : 'white' }}
          onClick={() => setView("calendar")}
        >
          <span style={{ fontWeight: 'bold', margin: 0, cursor: 'pointer', marginLeft: 5 }}>Calendar</span>
        </button>
        <button
          className="btn border border-dark rounded shadow-sm d-flex flex-row align-items-center gap-2"
          style={{ backgroundColor: view === 'stats' ? '#DADADA' : 'white' }}
          onClick={() => setView("stats")}
        >
          <span style={{ fontWeight: 'bold', margin: 0, cursor: 'pointer', marginLeft: 5 }}>Statistics</span>
        </button>

      </div>

      <div className="my-3">
        <ManagedInOdooNotice what="Time-off and incident requests" />
      </div>

      <LoadMask loading={isLoading} light>
        {view === "list" && (
          <DriversList
            requests={requests}
            typeOptions={typeOptions}
          />
        )}
      </LoadMask>

      {view === "calendar" && <Calendar />}

      {view === "stats" && <StatisticsBoard />}

      <DownloadModal
        showModal={showDlModal}
        handleCloseModal={() => {setShowDlModal(false), setDownloadType(null)}}
        type={downloadType}
      />

    </div>
  )
}

const mapStateToProps = (state) => ({
  user: state.login.userInfo,
});

export default connect(mapStateToProps)(TimeOff);
